import React from 'react'
import { useEmployeeDuty } from 'api/hooks/use-employee-duties'
import Table from 'react-bootstrap/Table'
import TableError from 'shared/tables/table-error'
import MutedText from 'shared/forms/muted-text'
import Spinner from 'react-bootstrap/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder } from '@fortawesome/free-solid-svg-icons'

function ConflictDetails({ employee, analytic, isActive }) {
  const params = {
    employee_id: employee.id,
    analytic_id: analytic.id
  }
  const options = {
    enabled: isActive
  }
  const {
    isSuccess,
    isLoading,
    isError,
    data: conflict
  } = useEmployeeDuty({ params, options })

  return (
    <div>
      <Table
        className="border-light border bg-white shadow-sm"
        responsive
        size="sm"
      >
        <thead>
          {isSuccess && (
            <tr>
              <th>{conflict.permission_name}</th>
              <th>{conflict.conflict_name}</th>
            </tr>
          )}
        </thead>
        <tbody>
          {isLoading && <Spinner animation="grow" variant="warning" />}

          {isSuccess &&
            conflict.conflicts.map((c, i, arr) => (
              <tr
                key={`role-conflict-${i}`}
                className={`border-top ${
                  arr.length - 1 === i ? 'border-light' : 'border-info'
                }`}
              >
                <td>
                  <>
                    <MutedText as="div" className="mt-1">
                      <small>Permission</small>
                    </MutedText>
                    <div className="mb-2">
                      <FontAwesomeIcon
                        icon={faFolder}
                        className="me-2 text-muted"
                      />
                      {c.permission_category_caption}:{' '}
                      {c.permission_description}
                    </div>
                    <div className="border-bottom border-light"></div>
                    <MutedText as="div" className="my-1">
                      <small>Role(s)</small>
                    </MutedText>
                    {c.permission_roles_list.sort().map((r) => (
                      <MutedText
                        as="div"
                        key={`role-${r}-${i}`}
                      >
                        <small>{r}</small>
                      </MutedText>
                    ))}
                  </>
                </td>
                <td>
                  <MutedText as="div" className="mt-1">
                    <small>Permission</small>
                  </MutedText>
                  <div className="mb-2">
                    <FontAwesomeIcon
                      icon={faFolder}
                      className="me-2 text-muted"
                    />
                    {c.conflict_permission_category_caption}:{' '}
                    {c.conflict_description}
                  </div>
                  <div className="border-bottom border-light"></div>
                  <MutedText as="div" className="my-1">
                    <small>Role(s)</small>
                  </MutedText>
                  <MutedText as="div">
                    {c.conflict_roles_list.sort().map((r) => (
                      <MutedText
                        as="div"
                        key={`role-${r}-${i}`}
                      >
                        <small>{r}</small>
                      </MutedText>
                    ))}
                  </MutedText>
                </td>
              </tr>
            ))}
          {isError && <TableError columns={3} />}
        </tbody>
      </Table>
    </div>
  )
}

export default ConflictDetails
